import { Translation } from '@ps/web-shared-components';
import React from 'react';

import Padlock from '../../assets/icons/padlock.svg';

import { TXTWCL_We_keep_your_data_safe } from './SafeInfoTitle.messages.json';
import { secure } from './SafeInfoTitle.scss';

const SafeInfoTitle: React.FC = () => (
  <div className={secure}>
    <Padlock />
    <Translation tagName="h3" {...TXTWCL_We_keep_your_data_safe} />
  </div>
);

export default SafeInfoTitle;
